(function ($, window) {
    // On document ready
    $(function () {

        const swiper = new Swiper('.swiper', { 
            // Optional parameters
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 500,
            autoplay: {
                delay: 5000,
            },

            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },

            // Navigation arrows
            // navigation: {
            //     nextEl: '.swiper-button-next',
            //     prevEl: '.swiper-button-prev',
            // },
        });
    });

})(jQuery, window);
